import { driver } from 'driver.js'
import type { Config, Driver } from 'driver.js'
import 'driver.js/dist/driver.css'

type DriverFactory = (config?: Config) => Driver

declare module '#app' {
  interface NuxtApp {
    $onboardingDriverFactory: DriverFactory
  }
}

function playwrightOnboardingDisabled(): boolean {
  try {
    return window.localStorage.getItem('monorga.playwright.disableOnboarding') === '1'
  } catch {
    return false
  }
}

/** Pas de calque driver.js pendant les campagnes Playwright : il intercepte les clics. */
function inertDriver(): Driver {
  const inert = {
    drive: () => {},
    moveNext: () => {},
    movePrevious: () => {},
    moveTo: () => {},
    highlight: () => {},
    destroy: () => {},
    isActive: () => false,
    refresh: () => {},
    getActiveIndex: () => undefined,
    getActiveElement: () => undefined,
    getActiveStep: () => undefined,
    getConfig: () => ({}),
    getState: () => undefined,
    setConfig: () => {},
    setSteps: () => {},
  }
  return inert as unknown as Driver
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      onboardingDriverFactory(config?: Config) {
        if (playwrightOnboardingDisabled()) {
          return inertDriver()
        }
        return driver(config)
      },
    },
  }
})
